export default "__VITE_ASSET__XJkipUeP__"